export default __webpack_public_path__ + "static/media/appels.aa0f49a3.svg";